var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"pie-graph",attrs:{"id":_vm.id,"viewBox":"0 0 200 200"}})
}
var staticRenderFns = []

export { render, staticRenderFns }